import axios from 'axios';
import dayjs from 'dayjs';
import {
  BASE_URL_SANDBOX,
  SAVE_ORDER,
  GET_VARIANT_PRODUCT_QUANTITY,
} from '../Constants/Config';
import { ToastifyAlert } from '../Constants/ToastifyAlert';

import { useDispatch, useSelector } from 'react-redux';
import {
  adjustPrices,
  deductCouponDiscount,
  formatDateOnlyYYYYMMDD,
  formatDateTimeOnly,
  getRoundValue,
  isProductCouponEligible,
  handleBogoDeals,
  handleMixAndMatchDeals,
  handleProductCategoryDiscounts,
  handleMkonnektDiscounts,
  selectIsDeziEnabled,
  parseDateOnlyLocal,
  updateCart,
} from '../utils';
import { updateCartItem } from '../redux/features/Cart/cartSlice';
import {
  buildMkonnektOrderQuoteFields,
  selectMatchingMkonnektDiscounts,
} from '../redux/features/MkonnektDiscount/mkonnektDiscountSlice';
import { isProductEligibleForLoyaltyPoints } from '../Components/Payment/Cart/CouponTipSectionLogic';
import { depositFeeName, depositForCartItem, round2 } from '../utils/containerDeposit';
import { getStoredCartVariant } from '../utils/variantMatrix';

const getOrderImageFileName = (image) => {
  const firstImage = String(image ?? '').split(',')[0].trim();
  if (
    !firstImage ||
    /^(data:|blob:)/i.test(firstImage) ||
    firstImage.includes('/static/media/')
  ) {
    return '';
  }
  return firstImage.split(/[?#]/)[0].split('/').pop() || '';
};

const Validation = () => {
  const maxDate = dayjs().add(45, 'year').endOf('year');

  const { isGuest } = useSelector((state) => state.authUser);
  const groupId = useSelector((state) => state.groupId);
  const storeDataState = useSelector((state) => state?.singleStores);
  const dispatch = useDispatch();
  const EmailReg = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  const regex = /[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]/;
  const PassNum = /\d/i;
  const PassUppercase = /^(?=.*[A-Z])/;
  const PassLowercase = /^(?=.*[a-z])/;
  const PassSpecCha = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/i;
  const onlySingleSpace = /^\s*[a-zA-Z]+(\s[a-zA-Z]+)*\s*$/;
  const Nameval = /^\s*[a-zA-Z]+(\s+[a-zA-Z]+)*\s*$/;
  const emoji =
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAB0}-\u{1FABF}\u{1FAC0}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}]/gu;

  const PassLeng = /^.{8,}$/i;
  const Space = /^[^\s]+$/i;
  const PhoneNo = /^\d{10}$/;
  const Numberval = /^\d*$/;
  const Characterval = /^[A-Za-z\s]+$/;
  const { productCategoryDiscounts } = useSelector(
    (state) => state.productCategoryDiscounts,
  );
  const mkonnektDiscounts = useSelector((state) => state.mkonnektDiscounts);
  const isDeziEnabled = useSelector(selectIsDeziEnabled);

  const validateEmail = (email, updatedErrors) => {
    if (email === '') {
      updatedErrors.username = 'Please enter email';
    } else if (emoji.test(email)) {
      updatedErrors.username = 'Emoji not allowed';
    } else if (!EmailReg.test(email)) {
      updatedErrors.username = 'Please enter valid email';
    } else {
      updatedErrors.username = '';
    }
  };
  const validatePassword = (password, updatedErrors) => {
    if (password === '') {
      updatedErrors.password = 'Please enter password';
    } else if (emoji.test(password)) {
      updatedErrors.password = 'Emoji not allowed';
    } else if (!PassUppercase.test(password)) {
      updatedErrors.password = 'Password should contain Uppercase letter';
    } else if (!PassLowercase.test(password)) {
      updatedErrors.password = 'Password should contain Lowercase letter';
    } else if (!PassNum.test(password)) {
      updatedErrors.password = 'Password should contain number';
    } else if (!PassSpecCha.test(password)) {
      updatedErrors.password = 'Password should contain Special Character';
    } else if (!PassLeng.test(password)) {
      updatedErrors.password = 'Length should be greater or equal to 8';
    } else if (!Space.test(password)) {
      updatedErrors.password = 'Space is not allow';
    } else if (password.length > 35) {
      updatedErrors.password = 'Length should not exceed 35 characters';
    } else {
      updatedErrors.password = '';
    }
  };

  const validatePasswordBlank = (password, updatedErrors) => {
    if (password === '') {
      updatedErrors.password = 'Please enter password';
    } else if (emoji.test(password)) {
      updatedErrors.password = 'Emoji not allowed';
    } else if (!Space.test(password)) {
      updatedErrors.password = 'Space is not allow';
    } else {
      updatedErrors.password = '';
    }
  };

  const validateOldPassword = (password, updatedErrors) => {
    if (password === '') {
      updatedErrors.oldpassword = 'Please enter old password';
    } else if (emoji.test(password)) {
      updatedErrors.oldpassword = 'Emoji not allowed';
    } else {
      updatedErrors.oldpassword = '';
    }
  };
  const validatePhoneNumber = (phone, updatedErrors) => {
    if (phone === '') {
      updatedErrors.phone = 'Please enter phone number';
    } else if (emoji.test(phone)) {
      updatedErrors.phone = 'Emoji not allowed';
    } else if (!PhoneNo.test(phone)) {
      updatedErrors.phone = 'Phone no not valid';
    } else {
      updatedErrors.phone = '';
    }
  };
  const validateCaptcha = (captcha, updatedErrors) => {
    if (captcha === '') {
      updatedErrors.recaptcha = 'Please check captcha';
    } else if (captcha === false) {
      updatedErrors.recaptcha = 'Please check captcha';
    } else {
      updatedErrors.recaptcha = '';
    }
  };

  const validateConfrimPassword = (
    confrimpassword,
    password,
    myconfString,
    updatedErrors,
  ) => {
    if (confrimpassword === '') {
      updatedErrors.confirmpassword = `Please ${myconfString}`;
    } else if (emoji.test(confrimpassword)) {
      updatedErrors.confirmpassword = 'Emoji not allowed';
    } else if (confrimpassword !== password) {
      updatedErrors.confirmpassword = 'Not matching with password';
    } else {
      updatedErrors.confirmpassword = '';
    }
  };

  const validateCardName = (fname, updatedErrors) => {
    if (fname === '') {
      updatedErrors.cardname = 'Please enter Card Name';
      return false;
    }
    if (emoji.test(fname)) {
      updatedErrors.cardname = 'Emoji not allowed';
      return false;
    }
    if (!Nameval.test(fname)) {
      updatedErrors.cardname = 'Name can only contain alphabets and spaces';
      return false;
    }
    if (!onlySingleSpace.test(fname)) {
      updatedErrors.cardname = 'Multiple spaces not allowed';
      return false;
    }
    updatedErrors.cardname = '';
    return true;
  };

  const validateFirstName = (fname, updatedErrors) => {
    if (fname === '') {
      updatedErrors.firstname = 'Please enter First Name';
    } else if (emoji.test(fname)) {
      updatedErrors.firstname = 'Emoji not allowed';
    } else if (!Nameval.test(fname) && fname) {
      updatedErrors.firstname = 'Name only contain alphabet';
    } else if (!onlySingleSpace.test(fname) && fname) {
      updatedErrors.firstname = 'Multiple spaces not allowed';
    } else {
      updatedErrors.firstname = '';
    }
  };
  const validateLastName = (lname, updatedErrors) => {
    if (lname === '') {
      updatedErrors.lastname = 'Please enter Last Name';
    } else if (emoji.test(lname)) {
      updatedErrors.lastname = 'Emoji not allowed';
    } else if (!Nameval.test(lname) && lname) {
      updatedErrors.lastname = 'Name only contain alphabet';
    } else if (!onlySingleSpace.test(lname) && lname) {
      updatedErrors.lastname = 'Multiple spaces not allowed';
    } else {
      updatedErrors.lastname = '';
    }
  };

  const validateStreetAddress = (street, updatedErrors) => {
    if (street === '') {
      updatedErrors.streetaddress = 'Please enter street address ';
    } else if (emoji.test(street)) {
      updatedErrors.streetaddress = 'Emoji not allowed';
    } else {
      updatedErrors.streetaddress = '';
    }
  };
  const validateState = (state, updatedErrors) => {
    if (state === '') {
      updatedErrors.state = 'Please enter state ';
    } else if (emoji.test(state)) {
      updatedErrors.state = 'Emoji not allowed';
    } else {
      updatedErrors.state = '';
    }
  };
  const validateIdNumber = (idnumber, updatedErrors) => {
    if (idnumber === '') {
      updatedErrors.idnumber = 'Please enter ID number ';
    } else if (emoji.test(idnumber)) {
      updatedErrors.idnumber = 'Emoji not allowed';
    } else {
      updatedErrors.idnumber = '';
    }
  };
  const formatCreditCardNumber = (inputNumber) => {
    // Remove any existing spaces
    let cleanedNumber = inputNumber.replace(/\s/g, '');

    // Use regex to add spaces every 4 digits
    let formattedNumber = cleanedNumber.replace(/(\d{4})/g, '$1 ');

    // Trim any leading or trailing spaces
    formattedNumber = formattedNumber.trim();

    return formattedNumber;
  };

  const validateCardNumber = (cardnumber, updatedErrors) => {
    if (cardnumber === '') {
      updatedErrors.cardnumber = 'Please enter Card Number';
    } else if (cardnumber.length < 13 || cardnumber.length > 16) {
      updatedErrors.cardnumber = 'Card number must be between 13 and 16 digits';
    } else if (emoji.test(cardnumber)) {
      updatedErrors.cardnumber = 'Emoji not allowed';
    } else {
      updatedErrors.cardnumber = '';
    }
  };

  const validateCvv = (cvv, updatedErrors) => {
    if (cvv === '') {
      updatedErrors.cvv = 'Please enter CVV';
    } else if (cvv.length !== 3 && cvv.length !== 4) {
      updatedErrors.cvv = 'CVV must be either 3 or 4 digits';
    } else if (emoji.test(cvv)) {
      updatedErrors.cvv = 'Emoji not allowed';
    } else {
      updatedErrors.cvv = '';
    }
  };

  const validateApartment = (apartment, updatedErrors) => {
    if (apartment === '') {
      updatedErrors.apartmentnumber = 'Please enter Suite/Apartment Number ';
    } else if (emoji.test(apartment)) {
      updatedErrors.apartmentnumber = 'Emoji not allowed';
    } else {
      updatedErrors.apartmentnumber = '';
    }
  };

  const validateCity = (city, updatedErrors) => {
    if (city === '') {
      updatedErrors.city = 'Please enter city ';
    } else if (emoji.test(city)) {
      updatedErrors.city = 'Emoji not allowed';
    } else if (!Characterval.test(city)) {
      updatedErrors.city = 'City  contain character';
    } else {
      updatedErrors.city = '';
    }
  };

  const validateZipCode = (zipcode, updatedErrors) => {
    if (zipcode === '') {
      updatedErrors.zipcode = 'Zipcode required';
    } else if (emoji.test(zipcode)) {
      updatedErrors.zipcode = 'Emoji not allowed';
    } else if (zipcode?.length !== 5) {
      updatedErrors.zipcode = 'Max 5 number enter';
    } else if (!Numberval.test(zipcode)) {
      updatedErrors.zipcode = 'Zipcode contain number ';
    } else {
      updatedErrors.zipcode = '';
    }
  };
  const validateIDproof = (idproof, updatedErrors) => {
    if (!idproof || idproof === '') {
      updatedErrors.idproof = 'Please select an ID type';
    } else {
      updatedErrors.idproof = '';
    }
  };

  function validateDateOfBirth(dateString) {
    // Parse the input date string
    const dob = new Date(dateString);

    // Check if the input is a valid date
    if (isNaN(dob.getTime())) {
      return false;
    }

    // Calculate the minimum allowed date (21 years ago from today)
    const minDate = new Date();
    minDate.setFullYear(minDate.getFullYear() - 21);

    // Check if the date of birth is at least 21 years old and not in the future
    return dob <= minDate && dob <= new Date();
  }

  const validateDOB = (DOB, updatedErrors) => {
    if (DOB === '' || DOB === 'NaN-aN-aN') {
      updatedErrors.DOB = '';
      // updatedErrors.DOB = 'Please enter date of birth  ';
    } else if (!validateDateOfBirth(DOB)) {
      updatedErrors.DOB = 'Eligibility 21 year old only ';
    } else {
      updatedErrors.DOB = '';
    }
  };

  const validateExpiredate = (expiredate, updatedErrors) => {
    const currentDate = new Date();
    const timestamp = currentDate.getTime();
    const timestampExpdate = Date.parse(expiredate);
    // Check if the selected date is after today
    const isDateValid = timestampExpdate > timestamp;
    if (expiredate === '') {
      updatedErrors.expiredate = 'Please enter Expiration Date';
    } else if (!isDateValid) {
      updatedErrors.expiredate = 'Expiration date cannot be earlier than today';
    } else {
      updatedErrors.expiredate = '';
    }
  };

  // const validateCardExpiredate = (expiredate, updatedErrors) => {
  //   // Check if the expiry year and month are greater than or equal to the next month's year and month
  //   if (expiredate === '') {
  //     updatedErrors.expiredate = 'Please enter Expiration Date';
  //   } else {
  //     updatedErrors.expiredate = '';
  //   }
  // };

  const validateCardExpiredate = (expiredate, updatedErrors) => {
    if (!expiredate) {
      updatedErrors.expiredate = 'Please enter Expiration Date';
    } else if (!dayjs(expiredate, 'MM/YYYY').isValid()) {
      updatedErrors.expiredate = 'Invalid date';
    } else if (dayjs(expiredate, 'MM/YYYY').year() > maxDate.year()) {
      updatedErrors.expiredate = `Year cannot be later than ${maxDate.year()}`;
    } else if (
      dayjs(expiredate, 'MM/YYYY').isBefore(
        dayjs().startOf('month').add(1, 'month'),
      )
    ) {
      updatedErrors.expiredate = 'Expiration date must be in the future';
    } else {
      updatedErrors.expiredate = '';
    }
  };

  const validateImageProof = (
    myfile,
    updatedErrors,
    msg = 'Please select document',
  ) => {
    if (!myfile) {
      updatedErrors.myfile = msg;
    } else {
      updatedErrors.myfile = '';
    }
  };

  const validateCoupon = (coupon, updatedErrors) => {
    if (regex.test(coupon)) {
      updatedErrors.coupon = ' Special character not allow';
    } else {
      updatedErrors.coupon = '';
    }
  };

  const convertToIndianTime = (usTime) => {
    if (usTime) {
      // Split the input time into hours and minutes
      const [hours, minutes] = usTime.split(':');

      // Create a Date object with the current date and the input hours and minutes
      const usDate = new Date();
      usDate.setHours(parseInt(hours, 10));
      usDate.setMinutes(parseInt(minutes, 10));

      // Convert the Date object to Indian time
      const options = {
        timeZone: 'Asia/Kolkata', // Indian Standard Time (IST) timezone
        hour12: true, // Use 12-hour format (true) or 24-hour format (false)
        hour: 'numeric', // Display hours
        minute: 'numeric', // Display minutes
      };

      const indianTime = usDate.toLocaleTimeString('en-IN', options);
      return indianTime;
    }
  };

  function getImageExtension(base64String) {
    // Extract the mime type from the base64 string
    const mimeType = base64String.match(
      /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,(.*)$/,
    );

    if (mimeType && mimeType[1]) {
      // Extract the file extension from the mime type
      const extension = mimeType[1].split('/').pop();
      return extension;
    }

    return null; // Unable to determine the extension
  }

  const formatExireDate = (originalDateString) => {
    return formatDateOnlyYYYYMMDD(originalDateString || '') || '';
  };

  const formatDate = (inputDate) => {
    let date =
      typeof inputDate === 'string' && inputDate.trim()
        ? parseDateOnlyLocal(inputDate.trim())
        : null;
    if (!date || isNaN(date.getTime())) {
      date = new Date(inputDate);
    }
    if (isNaN(date.getTime())) {
      return '';
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${month}/${day}/${year}`;
  };

  const percentOffItem = (price, compare_price) => {
    const percent = 100 - (parseFloat(price) / parseFloat(compare_price)) * 100;
    if (percent > 0) return parseInt(percent);
    else return 0;
  };

  const AddtoCart = (product, merchantId, merchant_data) => {
    const cartKey = `cart_${merchantId}`;
    let cartData = JSON.parse(localStorage.getItem(cartKey)) || [];

    // if user added a product from Product Details page with multiple qty, then go inside IF block
    // split all those multiple qty into 1 single single qty
    if (product.quantity > 1) {
      for (let i = 1; i <= product.quantity; i++) {
        const cartProduct = {
          ...product,
          quantity: 1,
          addedOn:
            cartData.length > 0 ? cartData[cartData.length - 1].addedOn + 1 : 1,
        };
        const updatedData = {
          ...cartProduct,
          merchant_data: merchant_data,
        };
        cartData.push(updatedData);
        localStorage.setItem(cartKey, JSON.stringify(cartData));
      }
    } else {
      const cartProduct = {
        ...product,
        addedOn:
          cartData.length > 0 ? cartData[cartData.length - 1].addedOn + 1 : 1,
      };
      const updatedData = {
        ...cartProduct,
        merchant_data: merchant_data,
      };
      cartData.push(updatedData);
      localStorage.setItem(cartKey, JSON.stringify(cartData));
    }
  };

  const checkInCart = (product, merchantId) => {
    const cartKey = `cart_${merchantId}`;
    let cartData = JSON.parse(localStorage.getItem(cartKey)) || [];

    const productExists = cartData.some((item) => {
      const sameProductId = item.productId === product.productId;

      // Check if all variants match
      if (
        (product.varients?.length || product.variantsSet) &&
        item.varients?.length
      ) {
        const sameVariants =
          product?.varients?.length > 0 &&
          product.varients.every((pVariant) => {
            // Find a matching variant in the cart item
            const matchingVariant = item.varients.find((variant) => {
              return (
                pVariant.varientName === variant.varientName &&
                pVariant.varientVl === variant.varientVl
              );
            });

            // If a matching variant is found for each pVariant, it means all variants match
            return !!matchingVariant;
          });

        const itemVariantSet = item?.varients
          ?.map((variant) => variant.varientVl)
          ?.join('/');

        const matchingVariants = product.variantsSet === itemVariantSet;

        return sameProductId && (sameVariants || matchingVariants);
      } else {
        return sameProductId;
      }
    });

    return productExists;
  };

  const UpdateQuantity = (
    productId,
    merchantId,
    categoryId,
    qty,
    type,
    cartProductId,
  ) => {
    const cartKey = `cart_${merchantId}`;
    // for local storage cart
    updateCart(cartKey, productId, type, cartProductId);
  };

  const getProductQuantity = (cartData, productId, merchantId, categoryId) => {
    const foundItem =
      cartData &&
      cartData.find((item) => {
        return item.productId === productId;
      });
    return foundItem ? parseInt(foundItem.quantity) : 1;
  };

  const isDecodedData = (str) => {
    try {
      return atob(str);
    } catch (error) {
      return false;
    }
  };
  const isValidJSON = (str) => {
    try {
      return JSON.parse(str);
    } catch (error) {
      return false;
    }
  };
  const filterProductData = (productInfo, productData) => {
    let productWithInfo = [];
    for (let index = 0; index < productInfo.length; index++) {
      const element = productInfo[index];
      let categoryArray = productData[element.categoryId];
      if (categoryArray && categoryArray.length) {
        let product = categoryArray.find(
          (e) =>
            e.id === element.productId && e.show_type === element.show_type,
        );
        if (product) {
          productWithInfo.push({
            productId: element.productId,
            categoryId: element.categoryId,
            product,
          });
        }
      }
    }
    return productWithInfo;
  };

  const filterCartData = (
    cartData,
    varientData,
    cartProductDetails,
    options = {},
  ) => {
    const rawCart = Array.isArray(cartData) ? cartData : [];
    const products = Array.isArray(cartProductDetails)
      ? cartProductDetails
      : [];
    const variants = Array.isArray(varientData) ? varientData : [];
    const productWithVarient = [];
    const normalizeId = (value) => String(value ?? '').trim();
    const normalizeMerchantId = (value) => normalizeId(value).toUpperCase();
    const requestedMerchantId = normalizeMerchantId(options?.merchantId);
    const parseQuantity = (value) => {
      if (
        (typeof value !== 'number' && typeof value !== 'string') ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        return null;
      }

      const quantity = Number(value);
      return Number.isInteger(quantity) && quantity > 0 ? quantity : null;
    };
    const parsePrice = (value) => {
      if (
        (typeof value !== 'number' && typeof value !== 'string') ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        return null;
      }

      const price = Number(value);
      return Number.isFinite(price) && price >= 0 ? price : null;
    };
    const processVariants = (selectedVariants) =>
      selectedVariants
        .map((variant) => String(variant?.varientVl ?? '').trim())
        .filter(Boolean)
        .join('/');
    const hasHydrationError = Boolean(options?.hasHydrationError);
    const createUnavailableItem = (element, product, message) => {
      const selectedQuantity = parseQuantity(element?.quantity) ?? 0;
      const unitPrice =
        parsePrice(
          element?.productPrice ?? product?.price ?? product?.compare_price,
        ) ?? 0;
      const merchantId = normalizeId(
        product?.merchant_id || element?.merchant_data?.merchant_id,
      );
      const fallbackProduct = product || {
        id: element?.productId,
        merchant_id: merchantId,
        title: element?.productTitle || 'Product unavailable',
        media: '',
        quantity: '0',
        isstockcontinue: '0',
        trackqnty: '1',
        isvarient: element?.varients?.length > 0 ? '1' : '0',
      };

      return {
        cartProductId: element?.cartProductId,
        productId: element?.productId,
        categoryId: element?.categoryId,
        addedOn: element?.addedOn,
        allVarients: Array.isArray(element?.allVarients)
          ? element.allVarients
          : [],
        varients: Array.isArray(element?.varients) ? element.varients : [],
        variant: element?.variant,
        variantLabel: element?.variantLabel,
        selectedQuantity,
        maxQuantity: 0,
        price: selectedQuantity * unitPrice,
        comparePrice: selectedQuantity * unitPrice,
        isOutOfStock: true,
        isUnavailable: !hasHydrationError,
        hasHydrationError,
        msg: message,
        pqLimitReached: false,
        product: fallbackProduct,
        productImage: element?.productImage || '',
        taxesAplicable: product?.other_taxes?.split(',') || [],
        uom: '',
        manufacturer: '',
        consumer_unit: '',
        upcCode: product?.upcCode ?? product?.upc ?? '',
        categoryName: product?.categoryName ?? product?.category_name ?? '',
        exclude_coupons_online: 1,
        allowCoupon: false,
      };
    };

    rawCart.forEach((element) => {
      if (!element || typeof element !== 'object') return;

      const product = products.find(
        (item) =>
          normalizeId(item?.id) === normalizeId(element.productId) &&
          (!requestedMerchantId ||
            normalizeMerchantId(item?.merchant_id) === requestedMerchantId),
      );

      if (!product) {
        productWithVarient.push(
          createUnavailableItem(
            element,
            null,
            hasHydrationError
              ? "We couldn't verify this item right now. Check your connection and try again."
              : 'This item is no longer available at this store. Remove it to continue.',
          ),
        );
        return;
      }

      const selectedQuantity = parseQuantity(element.quantity);
      if (selectedQuantity === null) {
        productWithVarient.push(
          createUnavailableItem(
            element,
            product,
            'This cart item has an invalid quantity. Remove it and add the item again.',
          ),
        );
        return;
      }

      if (Array.isArray(element.varients) && element.varients.length > 0) {
        const storedVariant = getStoredCartVariant(element);
        const selectedVariantName =
          storedVariant || processVariants(element.varients);
        const expectedMerchantId =
          requestedMerchantId || normalizeMerchantId(product?.merchant_id);
        const selectedVariant = variants.find(
          (variant) =>
            normalizeId(variant?.product_id) ===
              normalizeId(element.productId) &&
            String(variant?.variant ?? '').trim() === selectedVariantName &&
            (!expectedMerchantId ||
              normalizeMerchantId(variant?.merchant_id) ===
                expectedMerchantId),
        );

        if (!selectedVariant) {
          productWithVarient.push(
            createUnavailableItem(
              element,
              product,
              hasHydrationError
                ? "We couldn't verify this option right now. Try refreshing your cart."
                : 'This option is no longer available. Remove it and choose another option.',
            ),
          );
          return;
        }

        const unitPrice = parsePrice(selectedVariant.price);
        if (unitPrice === null) {
          productWithVarient.push(
            createUnavailableItem(
              element,
              product,
              'We could not verify the price for this option. Remove it and add the item again.',
            ),
          );
          return;
        }

        const compareUnitPrice =
          parsePrice(selectedVariant.compare_price) ?? unitPrice;
        productWithVarient.push({
          cartProductId: element.cartProductId,
          productId: element.productId,
          categoryId: element.categoryId,
          varients: element.varients,
          allVarients: element.allVarients,
          variant: element.variant,
          variantLabel: element.variantLabel,
          // Matrix items keep the combination.id they were added with.
          variantId:
            storedVariant &&
            element.variantId !== undefined &&
            element.variantId !== null &&
            element.variantId !== ''
              ? element.variantId
              : selectedVariant.id,
          addedOn: element.addedOn,
          selectedQuantity,
          maxQuantity: selectedVariant.quantity,
          price: selectedQuantity * unitPrice,
          comparePrice: selectedQuantity * compareUnitPrice,
          isOutOfStock: Boolean(element.isOutOfStock),
          msg: element.msg || '',
          pqLimitReached: Boolean(element.pqLimitReached),
          product,
          productImage: element.productImage || '',
          taxesAplicable: product?.other_taxes?.split(','),
          uom: selectedVariant?.uom || '',
          manufacturer: selectedVariant?.manufacturer || '',
          consumer_unit: selectedVariant?.consumer_unit || '',
          upcCode:
            selectedVariant?.upcCode ??
            selectedVariant?.upc ??
            product?.upcCode ??
            product?.upc ??
            '',
          categoryName:
            product?.categoryName ?? product?.category_name ?? '',
          exclude_coupons_online: product?.exclude_coupons_online ?? 0,
          allowCoupon: isProductCouponEligible(product),
          priceBook: selectedVariant.priceBook || null,
        });
        return;
      }

      const unitPrice = parsePrice(product.price);
      if (unitPrice === null) {
        productWithVarient.push(
          createUnavailableItem(
            element,
            product,
            'We could not verify the price for this item. Remove it and add the item again.',
          ),
        );
        return;
      }

      const compareUnitPrice = parsePrice(product.compare_price) ?? unitPrice;
      productWithVarient.push({
        cartProductId: element.cartProductId,
        productId: element.productId,
        categoryId: element.categoryId,
        allVarients: element.allVarients,
        varients: element.varients,
        addedOn: element.addedOn,
        selectedQuantity,
        maxQuantity: product.quantity,
        price: selectedQuantity * unitPrice,
        comparePrice: selectedQuantity * compareUnitPrice,
        isOutOfStock: Boolean(element.isOutOfStock),
        msg: element.msg || '',
        pqLimitReached: Boolean(element.pqLimitReached),
        product,
        productImage: element.productImage || '',
        uom: product?.uom || '',
        manufacturer: product?.manufacturer || '',
        consumer_unit: product?.consumer_unit || '',
        taxesAplicable: product?.other_taxes?.split(','),
        upcCode: product?.upcCode ?? product?.upc ?? '',
        categoryName: product?.categoryName ?? product?.category_name ?? '',
        exclude_coupons_online: product?.exclude_coupons_online ?? 0,
        allowCoupon: isProductCouponEligible(product),
        priceBook: product.priceBook || null,
      });
    });

    return productWithVarient;
  };

  const removeProductFromCart = (cartItem, cartKey) => {
    const cartData = JSON.parse(localStorage.getItem(cartKey));

    const updatedCartData = cartData.filter(
      (item) => item.addedOn !== cartItem.addedOn,
    );

    localStorage.setItem(cartKey, JSON.stringify(updatedCartData));
  };

  // on deleting a cart item inside the cart drawer
  const handleDeleteCartProduct = async (
    merchantId,
    variantData,
    cartData,
    cartItem,
    disableQuantityUpdate,
    setdisableQuantityUpdate,
    removeCartItem,
    setAddingProduct,
  ) => {
    // Safety check: return early if cartItem is undefined
    if (!cartItem) {
      if (setAddingProduct) setAddingProduct(false);
      return;
    }

    try {
      const { cartProductId, categoryId, productId, timeStamp, addedOn } =
        cartItem;
      const cartItemData = {
        cartProductId,
        categoryId,
        productId,
        timeStamp,
        addedOn,
      };
      const cartKey = `cart_${merchantId}`;

      if (cartItem.variantId) {
        // current selected product with complete live data
        const selectedProduct = variantData?.find(
          (prod) =>
            cartItem.variantId === prod?.id && productId === prod?.product_id,
        );

        // products inside cart with same product id and pq qty
        const productsWithSamePQ =
          variantData && variantData?.length > 0
            ? variantData?.filter((item) => {
                if (!item) return false;
                const { product_id, purchase_qty } = item;
                return (
                  product_id === selectedProduct?.product_id &&
                  selectedProduct?.purchase_qty === purchase_qty
                );
              })
            : [];

        const sameProductsVariantIds = productsWithSamePQ?.map(
          (item) => item.id,
        );

        // same other PQ products except current product
        const sameProductsFromCart = cartData?.filter(
          (item) =>
            sameProductsVariantIds.includes(item.variantId) &&
            item.addedOn !== cartItem.addedOn,
        );

        if (sameProductsFromCart && sameProductsFromCart?.length > 0) {
          sameProductsFromCart?.forEach(({ productId }) => {
            const bool =
              productId === cartItem?.product.id && disableQuantityUpdate;

            if (bool) {
              setdisableQuantityUpdate(false);
            }
          });
        }
      }

      dispatch(removeCartItem(cartItemData));
      removeProductFromCart(cartItemData, cartKey);
    } finally {
      // Reset addingProduct state after delete operation completes
      if (setAddingProduct) {
        setAddingProduct(false);
      }
    }
  };

  // update product price from cart in localstore
  const updateProductFromCart = (
    cartItem,
    cartKey,
    qty,
    type,
    cartProductId,
  ) => {
    // for local storage cart
    updateCart(cartKey, cartItem.productId, type, cartProductId);
  };

  // Only for variant product, disabling product if max qty reached in the cart drawer
  const allowUpdatingProduct = (
    variantId,
    productId,
    type,
    qty,
    currentProduct,
    variantData,
    cartData,
    setdisableQuantityUpdate,
  ) => {
    // selected product... jisko update karna hai.. complete data hai isme
    const selectedProduct = variantData?.find(
      (item) => item && item.id === variantId && item.product_id === productId,
    );

    // If selectedProduct not found, return early
    if (!selectedProduct) {
      return true;
    }

    // productId & purchase qty match karke dusre products find kiye hai from cart & complete data hai isme each product ke
    const productsWithSamePQ = variantData?.filter(
      (item) =>
        item &&
        item.product_id === selectedProduct.product_id &&
        selectedProduct.purchase_qty === item.purchase_qty,
    );

    // just getting product info from cartData...
    let dataset = [];
    productsWithSamePQ?.forEach((prod) => {
      if (prod) {
        const temp = cartData.filter(
          (item) =>
            item &&
            item.productId === prod.product_id &&
            item.variantId === prod.id,
        );

        dataset.push(...temp);
      }
    });

    // only storing the products with same PQ but not selected product
    const otherProducts =
      dataset &&
      dataset.length > 0 &&
      dataset?.filter(
        (product) =>
          product?.productId === selectedProduct?.product_id &&
          product?.variantId !== selectedProduct?.id,
      );

    const currentProductTotalQty =
      cartData.filter(
        (item) => item.cartProductId === currentProduct.cartProductId,
      ).length || 0;

    const totalQty =
      (otherProducts?.length || 0) +
      parseFloat(currentProductTotalQty) +
      (type === 'increment' ? 1 : 0);

    const maxQty = (input) => (type === 'increment' ? input - 1 : input);
    const productPurchaseQTY = parseFloat(selectedProduct.purchase_qty);

    // for not allowing user to add 1 more qty of the product...
    if (maxQty(totalQty) >= productPurchaseQTY) {
      setdisableQuantityUpdate(true);
      return false;
    }

    // if 1 more qty of the product is available for purchase then allowing...
    return true;
  };

  // on increasing or decreasing product qty inside the cart drawer
  const handleUpdateCartItem = async (
    product,
    qty,
    type,
    setdisableQuantityUpdate,
    merchantId,
    variantData,
    cartData,
    setAddingProduct, // stopping users from adding products instantly unless previous one is added
  ) => {
    const { cartProductId, categoryId, productId, variantId, addedOn, price } =
      product;
    let store_method_id = localStorage.getItem('orderRecord');
    // checking product qty.. if not available then disable the button
    if (product && product.varients && product.varients.length >= 1) {
      const bool = allowUpdatingProduct(
        variantId,
        productId,
        type,
        qty,
        product,
        variantData,
        cartData,
        setdisableQuantityUpdate,
      );

      // disabling increment button if no more qty available
      if (!bool) {
        setdisableQuantityUpdate(true);
        setAddingProduct(false);
        return;
      }

      const data = {
        merchant_id: product.product.merchant_id,
        product_id: productId,
        variant_id: variantId,
        quantity: qty,
      };
      try {
        const response = await axios.post(
          BASE_URL_SANDBOX + GET_VARIANT_PRODUCT_QUANTITY,
          data,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );

        if (
          response.data.status === 200 &&
          parseInt(response.data.result.quantity) >= qty
        ) {
          const cartItem = {
            cartProductId: cartProductId,
            categoryId: categoryId,
            productId: productId,
            quantity: qty,
            addedOn,
            type,
            product,
            productPrice: price,
            orderMethod: store_method_id,
          };

          const cartKey = `cart_${merchantId}`;
          dispatch(updateCartItem(cartItem));
          updateProductFromCart(cartItem, cartKey, qty, type, cartProductId);
          setdisableQuantityUpdate(false);
        } else if (response.data.status === 400) {
          setdisableQuantityUpdate(true);
          ToastifyAlert('Maximum quantity reached', 'error');
        }
      } catch (error) {
        return new Error('Something went wrong');
      } finally {
        setAddingProduct(false);
      }
    } else {
      const data = {
        merchant_id: merchantId,
        product_id: productId,
        variant_id: '',
        quantity: qty,
      };

      try {
        const response = await axios.post(
          BASE_URL_SANDBOX + GET_VARIANT_PRODUCT_QUANTITY,
          data,
          { headers: { 'Content-Type': 'multipart/form-data' } },
        );

        if (
          response.data.status === 200 &&
          parseInt(response.data.result.quantity) >= qty
        ) {
          setdisableQuantityUpdate(false);

          const cartItemadd = {
            cartProductId,
            categoryId,
            productId,
            quantity: qty,
            addedOn,
            type,
            product,
            productPrice: price,
            orderMethod: store_method_id,
          };

          const cartKey = `cart_${merchantId}`;
          dispatch(updateCartItem(cartItemadd));
          updateProductFromCart(cartItemadd, cartKey, qty, type, cartProductId);
        } else if (response.data.status === 400) {
          setdisableQuantityUpdate(true);
          ToastifyAlert('Maximum quantity reached', 'error');
        }
      } catch (error) {
        return new Error('Something went wrong');
      } finally {
        setAddingProduct(false);
      }
    }
  };

  // to get the varient price and quantity we need to run api for all products who have varients and by varients we can get the price and quantity
  const filterVarientDataFromCart = (cartData, merchant) => {
    const outputData = [];

    cartData &&
      cartData?.length >= 1 &&
      cartData?.forEach((item) => {
        if (item && item?.varients && item?.varients?.length > 0) {
          const product_id = parseInt(item.productId);
          const merchant_id = merchant;
          const variant =
            getStoredCartVariant(item) ||
            (item.varients &&
              item.varients.length >= 1 &&
              item.varients.map((variant) => variant.varientVl).join('/'));

          outputData.push({
            merchant_id,
            product_id,
            variant,
          });
        }
      });

    const outputJson = outputData;
    return outputJson;
  };

  // varient transformer for single product page
  const varientTransformer = (originalObject) => {
    if (originalObject !== null && originalObject !== undefined) {
      const transformedArray = [];

      for (let i = 1; i <= 3; i++) {
        const optKey = `options${i}`;
        const optValKey = `optionsvl${i}`;

        const obj = {
          [optKey]: originalObject && originalObject[optKey],
          [optValKey]:
            originalObject && originalObject[optValKey]
              ? originalObject[optValKey].split(',')
              : [],
        };

        transformedArray.push(obj);
      }
      return transformedArray;
    }
    return 0;
  };

  const handleGetVariData = (selectedVarient, VarientData) => {
    const foundItem =
      VarientData &&
      VarientData.find((item) => {
        return item.variant === selectedVarient;
      });
    return foundItem;
  };

  const handleImagesArray = (filenames) => {
    if (filenames && typeof filenames === 'string') {
      const filenamesArray = filenames.split(',');
      if (filenamesArray.length >= 1) {
        return filenamesArray;
      }
    }
    return [];
  };

  const getCurrentDateTime = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    return formattedDateTime;
  };

  const category = (id, allCategories) => {
    const categoryId = id?.split(',')[0] ? id?.split(',')[0] : id;
    const foundCategory =
      allCategories &&
      allCategories.find(
        (item) => item.id == categoryId || item.collection_id == categoryId,
      );
    return foundCategory?.title || foundCategory?.collection_title;
  };

  const createFullName = (productName, varientArray) => {
    if (varientArray.length >= 1) {
      const temp = varientArray
        .map(({ varientVl }) => `${varientVl}`)
        .join('/');

      const fullName = `${productName}-${temp}`;

      return fullName;
    } else {
      return productName;
    }
  };

  const createVarientTitle = (varientArray) => {
    //"small/green/test2"
    return varientArray.map(({ varientVl }) => `${varientVl}`).join('/');
  };

  const createNote = (productName, varientArray) => {
    if (varientArray.length >= 1) {
      const name = `Name-${productName}`;
      const note = varientArray
        .map(({ varientName, varientVl }, index) => {
          return `${varientName}-${varientVl}`;
        })
        .join('~');

      const newNote = `${name}~${note}`;
      return newNote;
    } else {
      return `Name-${productName}`;
    }
  };

  const calculateDefaultTax = (taxDetailApiData, tax, taxName, price) => {
    const allTaxes = tax?.split(',').map(Number);

    let matchedTax = false;
    let percentData = 0;

    for (let index = 0; index < allTaxes?.length; index++) {
      const element = allTaxes[index];
      const data = taxDetailApiData.find((item) => {
        return item.id == element && item.title === 'DefaultTax';
      });

      if (data) {
        matchedTax = true;
        percentData = data;
        break;
      }
    }

    if (matchedTax) {
      if (taxName === 'tax_rate') {
        return parseFloat(percentData.percent);
      } else {
        // const isPercentTax = +percentData.type === 0;
        // const taxApplied = isPercentTax
        //   ? (parseFloat(price) * parseFloat(percentData.percent)) / 100
        //   : percentData.percent;

        const taxApplied =
          (parseFloat(price) * parseFloat(percentData.percent)) / 100;
        const taxRoundedValue = getRoundValue(taxApplied);
        return parseFloat(taxRoundedValue).toFixed(2);
      }
    } else {
      return 0;
    }
  };

  const calculateOtherTax = (tax, price, taxName, taxDetailApiData) => {
    const allTaxes = tax?.split(',').map(Number);
    let sumtax = 0;
    let taxObject = {};

    for (let index = 0; index < allTaxes?.length; index++) {
      const element = allTaxes[index];
      const matchedTax = taxDetailApiData.find(
        (item) => item.id == element && item.title !== 'DefaultTax',
      );

      if (matchedTax) {
        // const isPercentTax = +matchedTax.type === 0;
        // const taxApplied = isPercentTax
        //   ? (parseFloat(price) * parseFloat(matchedTax?.percent)) / 100
        //   : matchedTax?.percent;

        const taxApplied =
          (parseFloat(price) * parseFloat(matchedTax?.percent)) / 100;

        const newSumTax =
          ((parseFloat(sumtax) + parseFloat(getRoundValue(taxApplied))) * 100) /
          100;
        sumtax = parseFloat(newSumTax).toFixed(2);
        taxObject[matchedTax?.title] = getRoundValue(taxApplied);
      }
    }

    if (taxName === 'taxJson') {
      function isObjectEmpty(taxObject) {
        for (let key in taxObject) {
          if (taxObject.hasOwnProperty(key)) {
            return false; // Object is not empty
          }
        }
        return true; // Object is empty
      }
      return isObjectEmpty(taxObject) ? '' : JSON.stringify(taxObject);
    } else {
      return parseFloat(sumtax).toFixed(2);
    }
  };

  const getTaxesData = (productTaxes, taxDetailApiData) => {
    const taxObj = {};
    const default_tax = productTaxes?.split(',').map(Number);

    for (let index = 0; index < default_tax?.length; index++) {
      const element = default_tax[index];
      const matchedTax = taxDetailApiData.find(
        (item) => item.id == element && item.title !== 'DefaultTax',
      );
      if (matchedTax) {
        const value = parseFloat(matchedTax?.percent);
        taxObj[matchedTax?.title] = value;
      }
    }

    // if tax available then ok.. else sending blank string
    if (Object.keys(taxObj)?.length > 0) {
      return JSON.stringify(taxObj);
    } else {
      return '';
    }
  };

  const pennyFixLogic = (
    newCartItems = [],
    percentageDeducCoupon = 0,
    percentageDeducLoy = 0,
    lpAmount = 0,
  ) => {
    const getDiscountedPrice = (price, percentage, condition) => {
      const discount = getRoundValue((price * percentage) / 100);
      const newPrice = getRoundValue(price - discount);

      return condition ? newPrice : price;
    };

    // ------------- Deducting coupon discount
    let pennyFixProducts = newCartItems.map((item) => {
      // const pennyFixedPrice = getDiscountedPrice(
      //   item.price,
      //   percentageDeducCoupon,
      //   percentageDeducCoupon > 0 && item.allowCoupon,
      // );

      const applyCouponDiscount = percentageDeducCoupon > 0 && item.allowCoupon;

      const pennyFixedPrice = applyCouponDiscount
        ? deductCouponDiscount(item.price, percentageDeducCoupon)
        : item.price;

      return {
        ...item,
        price: pennyFixedPrice,
        pennyFixedPrice,
        couponDiscountAmount: getRoundValue(item.price - pennyFixedPrice),
      };
    });

    const subtotal = newCartItems
      .filter((item) => item.allowCoupon)
      .reduce((acc, curr) => {
        acc = parseFloat(acc) * 1 + parseFloat(curr.price) * 1;
        return getRoundValue(acc);
      }, 0);


    const totalDiscount = subtotal * (percentageDeducCoupon / 100);

    const actualCouponDiscount = getRoundValue(totalDiscount);

    const calculateAppliedDiscount = (items, key) =>
      items.reduce(
        (acc, curr) => getRoundValue(acc + parseFloat(curr[key] || 0)),
        0,
      );

    const couponApplied = calculateAppliedDiscount(
      pennyFixProducts,
      'couponDiscountAmount',
    );

    const couponDifference = getRoundValue(
      couponApplied - actualCouponDiscount,
    );

    if (couponDifference !== 0 && percentageDeducCoupon > 0) {
      pennyFixProducts = adjustPrices(
        pennyFixProducts,
        couponDifference,
        'couponDiscountAmount',
        couponApplied > actualCouponDiscount,
      );
    }


    // -------------------- Deducting LP discount
    if (percentageDeducLoy > 0) {
      pennyFixProducts = pennyFixProducts.map((item) => {
        const itemPrice = item.pennyFixedPrice || item.price || 0;
        const pennyFixedPrice = getDiscountedPrice(
          itemPrice,
          percentageDeducLoy,
          isProductEligibleForLoyaltyPoints(item, storeDataState),
        );

        return {
          ...item,
          price: pennyFixedPrice,
          pennyFixedPrice,
          lpDiscountAmount: getRoundValue(itemPrice - pennyFixedPrice),
        };
      });

      const totalLPApplied = calculateAppliedDiscount(
        pennyFixProducts,
        'lpDiscountAmount',
      );
      const lpDifference = getRoundValue(totalLPApplied - lpAmount);

      if (lpDifference !== 0) {
        pennyFixProducts = adjustPrices(
          pennyFixProducts,
          lpDifference,
          'lpDiscountAmount',
          totalLPApplied > lpAmount,
        );
      }
    }

    return pennyFixProducts;
  };

  const JsonItem = (
    newCartItems,
    taxDetailApiData,
    allCategories,
    percentageDeducCoupon,
    percentageDeducLoy,
    lpAmount,
    couponData,
  ) => {
    const couponApplied =
      percentageDeducCoupon &&
      !isNaN(percentageDeducCoupon) &&
      percentageDeducCoupon > 0;

    const loyaltyPointsApplied =
      percentageDeducLoy &&
      !isNaN(percentageDeducLoy) &&
      percentageDeducLoy > 0;

    const doPennyFix = couponApplied || loyaltyPointsApplied;

    // penny fix logic goes here...
    if (doPennyFix) {
      newCartItems = pennyFixLogic(
        newCartItems,
        percentageDeducCoupon,
        percentageDeducLoy,
        lpAmount,
      );
    }

    const myJsonData = [];
    for (let index = 0; index < newCartItems.length; index++) {
      const element = newCartItems[index];

      const result = element.pennyFixedPrice
        ? element.pennyFixedPrice
        : element.price
          ? element.price
          : 0;

      const bogoDiscount = element?.bogoDiscountApplied
        ? parseFloat(element?.bogoDiscount)
        : 0;

      const mixAndMatchDiscount = element?.mixAndMatchDiscountApplied
        ? parseFloat(element.mixAndMatchDiscount)
        : 0;

      const mkonnektDiscount = element?.mkonnektDiscountApplied
        ? parseFloat(element.mkonnektDiscount)
        : 0;

      // Container deposit: added to this line's taxable base when it is taxed.
      const deposit = depositForCartItem(element);
      const lineTaxBase = result * element?.selectedQuantity ?? 0;
      const taxBase = lineTaxBase + (deposit?.taxable ? deposit.amount : 0);

      const tax =
        calculateDefaultTax(
          taxDetailApiData,
          element?.product?.other_taxes,
          'tax',
          taxBase,
        ) ?? '';

      const taxRate =
        calculateDefaultTax(
          taxDetailApiData,
          element?.product?.other_taxes,
          'tax_rate',
        ) ?? '';

      const otherTaxes =
        calculateOtherTax(
          element?.product?.other_taxes,
          taxBase,
          'taxCalculate',
          taxDetailApiData,
        ) ?? '';

      const otherTaxesDesc =
        calculateOtherTax(
          element?.product?.other_taxes,
          taxBase,
          'taxJson',
          taxDetailApiData,
        ) ?? '';

      const depositTax =
        deposit?.taxable
          ? round2(
              (Number(tax) || 0) -
                (Number(
                  calculateDefaultTax(
                    taxDetailApiData,
                    element?.product?.other_taxes,
                    'tax',
                    lineTaxBase,
                  ),
                ) || 0) +
                (Number(otherTaxes) || 0) -
                (Number(
                  calculateOtherTax(
                    element?.product?.other_taxes,
                    lineTaxBase,
                    'taxCalculate',
                    taxDetailApiData,
                  ),
                ) || 0),
            )
          : 0;
      // console.log('otherTaxesDesc: ', otherTaxesDesc);

      // taxes_type_desc: {"RTAX":{val:"10.15",type:"rate"},"MTAX":{val:"8",type:"amount"}}
      const taxesTypeDesc = {};
      const productTaxes = element?.product?.other_taxes;
      if (productTaxes?.length > 0) {
        productTaxes.split(',').forEach((prodTax) => {
          const taxMatched = taxDetailApiData.find(
            (tax) => +tax.id === +prodTax,
          );
          if (taxMatched) {
            const taxValue =
              taxMatched.title === 'DefaultTax'
                ? tax
                : JSON.parse(otherTaxesDesc)[taxMatched.title];
            taxesTypeDesc[taxMatched.title] = {
              // val: getRoundValue(taxMatched.percent),
              val: getRoundValue(taxValue),
              type: +taxMatched.type === 0 ? 'rate' : 'amount',
            };
          }
        });
      }


      const couponDiscountValue = Math.abs(
        parseFloat(element?.couponDiscountAmount || 0),
      );
      const bogoDiscountValue = Math.abs(parseFloat(bogoDiscount || 0));
      const mixMatchDiscountValue = Math.abs(parseFloat(mixAndMatchDiscount || 0));

      const newElement = {
        bulk_price_id: element?.mixAndMatchId ? element?.mixAndMatchId : '',
        is_bulk_price: element?.mixAndMatchId ? '1' : '0',
        mix_match_amt: (parseFloat(mixAndMatchDiscount) * -1).toFixed(2),
        bogo_discount: parseFloat(bogoDiscount).toFixed(2),
        bogo_id:
          element?.bogoId && parseFloat(element?.bogoId) > 0
            ? element?.bogoId
            : '',
        img: getOrderImageFileName(
          element?.productImage || element?.product?.media,
        ),
        use_point: element?.product?.use_point,
        earn_point: element?.product?.earn_point,
        product_id: element?.product?.id ?? '',
        name: element?.product?.title ?? '',
        variant_id: element?.variantId ?? '',
        variant_title:
          getStoredCartVariant(element) ||
          (createVarientTitle(element?.varients) ?? ''),
        category_id: element?.categoryId?.split(',')[0] ?? '',
        cat_title: category(element?.categoryId, allCategories) ?? '',
        fullname: getStoredCartVariant(element)
          ? `${element?.product?.title ?? ''}-${getStoredCartVariant(element)}`
          : createFullName(element?.product?.title, element?.varients) ?? '',
        note: createNote(element?.product?.title, element?.varients) ?? '',
        price: parseFloat(result).toFixed(2),
        // inventoryPrice: element.inventoryPrice ? element.inventoryPrice : 0,
        inventory_price: element.inventoryPrice ? element.inventoryPrice : 0,
        qty: element?.selectedQuantity.toString() ?? 0,
        tax_rate: taxRate,
        lp_discount_amount: element.lpDiscountAmount
          ? element.lpDiscountAmount
          : 0,
        coupon_code_amt: element.couponDiscountAmount
          ? element.couponDiscountAmount
          : 0,
        tax,
        other_tax: otherTaxes,
        other_tax_desc: otherTaxesDesc,
        other_taxes_rate_desc: getTaxesData(
          element?.product?.other_taxes,
          taxDetailApiData,
        ),
        uom: element?.uom || '',
        manufacturer: element?.manufacturer || '',
        consumer_unit: element?.consumer_unit || '',
        ...(deposit
          ? {
              deposit_per_item: deposit.perItem,
              deposit_amount: deposit.amount,
              deposit_tax: depositTax,
            }
          : {}),
        // taxes_type_desc: JSON.stringify(taxesTypeDesc),

        altria_discount_desc:{
          coupon: {
            code: couponData?.name || "",
            discount: element?.couponDiscountAmount || 0,
            altria_funded_discount:
              couponDiscountValue > 0
                ? couponData?.altria_funded_discount || 0
                : 0,
            promotion_code:
              couponDiscountValue > 0 ? couponData?.promotion_code || "" : "",
          },
          bogo: {
            code: element?.bogoDealName || "",
            discount: bogoDiscount,
            altria_funded_discount:
              bogoDiscountValue > 0 ? element?.altria_funded_discount || 0 : 0,
            promotion_code:
              bogoDiscountValue > 0 ? element?.bogoPromotionCode || "" : "",
          },
          mix_match: {
            code: element?.mixAndMatchDealName || "",
            discount: mixAndMatchDiscount,
            altria_funded_discount:
              mixMatchDiscountValue > 0
                ? element?.altria_funded_discount || 0
                : 0,
            promotion_code:
              mixMatchDiscountValue > 0
                ? element?.mixAndMatchPromotionCode || ""
                : "",
          },
          mkonnekt: {
            discount: mkonnektDiscount,
            breakdown: element?.mkonnektDiscountBreakdown || [],
          },
        }
      };
      myJsonData.push(newElement);
    }


    const convertedObject = {};
    myJsonData.forEach((item, index) => {
      convertedObject[index] = item;
    });

    return convertedObject;
  };

  // Builds the same `data` payload that place_Order POSTs, but returns it
  // synchronously instead of sending. Used by the wallet flow so Apple Pay /
  // Google Pay POST the identical payload to /Process_order_online/saveOrder
  // (with payment_method/wallet_token overrides) — keeps wallet feature parity
  // with card checkout (loyalty, store credit, BOGO, mix-match, future orders,
  // group routing, ID card, notifications, etc.).
  const buildPlaceOrderData = (
    selectedDeliveryAdderess,
    couponData,
    accountInfoData,
    authuserData,
    storeDataState,
    finalAmountInfo,
    cartData,
    taxDetailApiData,
    totalTaxInfo,
    allCategories,
    paymentDPdata,
    lp_sc_data,
    discountAmt,
    percentageDeducCoupon,
    percentageDeducLoy,
    sendNotifications,
    bogoList = [],
    mixAndMatchList = [],
    notificationSettings,
    deliveryQuoteData = {},
    mkonnektDiscountRequestBody = null,
  ) => {
    // mKonnekt (dezi) runs first so tobacco items are excluded from local deals.
    // Same gate as checkout pricing: only the quote settled for this cart's
    // request applies, so a timed-out or stale quote never prices the order.
    const afterMkonnekt = isDeziEnabled
      ? handleMkonnektDiscounts(
          cartData,
          selectMatchingMkonnektDiscounts(
            mkonnektDiscounts,
            mkonnektDiscountRequestBody,
          ),
        )
      : cartData;
    const afterProductCategoryDiscounts = handleProductCategoryDiscounts(
      afterMkonnekt,
      productCategoryDiscounts,
    );
    const afterBogoCart = handleBogoDeals(
      afterProductCategoryDiscounts,
      bogoList.bogoList,
    );
    const afterMixAndMatchCart = handleMixAndMatchDeals(
      afterBogoCart,
      mixAndMatchList.mixAndMatchList,
    );

    const Items = JsonItem(
      afterMixAndMatchCart,
      taxDetailApiData,
      allCategories,
      percentageDeducCoupon,
      percentageDeducLoy,
      lp_sc_data?.spend_loyality_amount,
      couponData,
    );

    const otherTaxes = (taxObj, qty) => {
      const json = JSON.parse(taxObj);
      const newObj = {};
      for (let key in json) {
        newObj[key] = json[key] / qty;
      }

      return JSON.stringify(newObj);
    };

    const values = Object.values(Items);

    const totalBogoDiscount =
      values && values.length > 0
        ? values.reduce(
            (acc, curr) => (acc += parseFloat(curr.bogo_discount)),
            0,
          )
        : 0;

    const finalSubTotal =
      values && values.length > 0
        ? values.reduce((acc, curr) => {
            // const mixAndMatchDiscountApplied = curr.is_bulk_price === '1';
            // const mixAndMatchDiscount = mixAndMatchDiscountApplied
            //   ? Math.abs(curr.mix_match_amt)
            //   : 0;

            // acc += parseFloat(curr.inventory_price) - mixAndMatchDiscount;
            acc += parseFloat(curr.inventory_price);

            return acc;
          }, 0)
        : 0;


    // Making all the line items individual if qty is more than 1
    const newLineItems = {};
    values.forEach((item) => {
      if (item.qty > 1) {
        for (let i = 0; i < item.qty; i++) {
          const newLength = Object.keys(newLineItems).length;
          newLineItems[newLength] = {
            ...item,
            tax: item.tax / item.qty,
            qty: 1,
            coupon_code_amt:
              parseFloat(item.coupon_code_amt) && !isNaN(item.coupon_code_amt)
                ? item.coupon_code_amt / item.qty
                : 0,
            other_tax: item.other_tax / item.qty,
            other_tax_desc: item.other_tax_desc
              ? otherTaxes(item.other_tax_desc, item.qty)
              : '',
            ...(item.deposit_amount
              ? {
                  deposit_amount: round2(item.deposit_amount / item.qty),
                  deposit_tax: item.deposit_tax / item.qty,
                }
              : {}),
          };
        }
      } else {
        const newLength = Object.keys(newLineItems).length;
        newLineItems[newLength] = item;
      }
    });

    const depositAmt = round2(
      Object.values(newLineItems).reduce(
        (sum, line) => sum + (Number(line.deposit_amount) || 0),
        0,
      ),
    );

    // final discount amount
    const totalCouponDiscountAmount =
      newLineItems && Object.values(newLineItems).length > 0
        ? Object.values(newLineItems).reduce((acc, curr) => {
            const couponCodeAmount = curr.coupon_code_amt
              ? curr.coupon_code_amt
              : 0;

            acc = getRoundValue(parseFloat(acc) + parseFloat(couponCodeAmount));
            return acc;
          }, 0)
        : 0;

    // const finalDiscountAmount =
    //   parseFloat(totalBogoDiscount) + parseFloat(totalCouponDiscountAmount);

    const finalDiscountAmount = parseFloat(totalCouponDiscountAmount);

    // creating Other Taxes json object,
    // {GST: "18", CGST: "9", SGST: "9", ...} the values are actual percentages set for other Taxes
    const otherTaxesRateDescObject = {};
    if (Items && Object.keys(Items).length > 0) {
      for (let item in Items) {
        const otherTaxes = Items[item].other_taxes_rate_desc;
        if (otherTaxes) {
          const parsedTaxObject = JSON.parse(otherTaxes); // {GST: "18.12", CGST: "9.06"}
          const keys = Object.keys(parsedTaxObject); // ["GST", "CGST"]
          if (otherTaxes && keys.length > 0) {
            keys.forEach((key) => {
              if (!otherTaxesRateDescObject[key]) {
                otherTaxesRateDescObject[key] = parsedTaxObject[key];
              }
            });
          }
        }
      }
    }

    const otherTaxesRateDesc =
      Object.keys(otherTaxesRateDescObject)?.length <= 0
        ? ''
        : JSON.stringify(otherTaxesRateDescObject);

    const finalCalculateDefaultTax = (taxName) => {
      if (taxName === 'default') {
        const value =
          parseFloat(
            totalTaxInfo &&
              totalTaxInfo['DefaultTax'] &&
              totalTaxInfo['DefaultTax'],
          ) || 0;
        return value?.toFixed(2) || 0;
      } else {
        if (totalTaxInfo['DefaultTax'] !== undefined) {
          const matchingItem = taxDetailApiData.find(
            (item) => item.title === 'DefaultTax',
          );
          return matchingItem ? parseFloat(matchingItem.percent).toFixed(3) : 0;
        }
      }
    };

    const finalCalculateOtherTax = () => {
      const sumOfOtherTaxes = Object.keys(totalTaxInfo)
        .filter((key) => key !== 'DefaultTax')
        .reduce((sum, key) => sum + parseFloat(totalTaxInfo[key]), 0);

      return parseFloat(sumOfOtherTaxes).toFixed(2);
    };

    const calculateOtherTaxdesc = () => {
      const otherTaxInfo = Object.keys(totalTaxInfo)
        .filter((key) => key !== 'DefaultTax')
        .reduce((result, key) => {
          result[key] = parseFloat(totalTaxInfo[key] || 0).toFixed(2);
          return result;
        }, {});

      if (
        typeof otherTaxInfo === 'object' &&
        Object.keys(otherTaxInfo).length === 0
      ) {
        return '';
      } else {
        // Handle other cases if needed
        return JSON.stringify(otherTaxInfo);
      }
    };
    const finalAmountIsAboveZero =
      parseFloat(Number(finalAmountInfo?.grandTotal || 0).toFixed(2)) > 0;

    const totalMixMatchDiscount = Object.values(newLineItems)?.reduce(
      (acc, item) => {
        return acc + Math.abs(parseFloat(item.mix_match_amt || 0));
      },
      0,
    );

    const _uuid = crypto.randomUUID();

    const data = {
      merchant_id: storeDataState?.merchant_id ?? '',
      is_guest: isGuest === 'yes' ? 'yes' : 0,
      is_future:
        storeDataState?.future_ordering === '1' &&
        paymentDPdata?.pickUpLaterDate &&
        paymentDPdata?.pickupTime
          ? 1
          : 0,
      f_date: paymentDPdata?.pickUpLaterDate ?? '',
      f_time: paymentDPdata?.pickupTime ?? '',
      card_name: paymentDPdata?.cardname ?? '',
      // Source object (authUser.UserData) comes from several backend endpoints
      // whose shapes differ — some return `id`, others `customer_id` (see the
      // same fallback at useAuthModalLogic.js saveAddressToBackend). Fall back
      // so every order carries a customer_id regardless of which key is present.
      customer_id: authuserData?.id || authuserData?.customer_id || '',
      customer_name: authuserData?.name,
      ccOrder:
        paymentDPdata?.paymentType === 'newcash' ||
        (!finalAmountIsAboveZero && parseFloat(finalAmountInfo.mytipamt) <= 0)
          ? 0
          : 1,
      cus_email: authuserData?.email,
      bill_fname: accountInfoData?.message?.f_name ?? '',
      bill_lname: accountInfoData?.message?.l_name ?? '',
      bill_phone: accountInfoData?.message?.phone ?? '',
      bill_address: accountInfoData?.message?.a_address_line_1 ?? '',
      bill_address_2: accountInfoData?.message?.a_address_line_2 ?? '',
      bill_city: accountInfoData?.message?.a_city ?? '',
      bill_state: accountInfoData?.message?.a_state ?? '',
      bill_zip: accountInfoData?.message?.a_zip ?? '',
      // id_card_no: accountInfoData?.message?.i_card_number ?? '',
      // id_card_type: accountInfoData?.message?.i_card_type ?? '',
      // id_card_dob: accountInfoData?.message?.i_card_dob ?? '',
      // id_card_expiry: accountInfoData?.message?.i_card_ex_date ?? '',
      id_card_no:
        isGuest !== 'yes'
          ? (accountInfoData?.message?.i_card_number ?? '')
          : JSON.parse(localStorage.getItem('guestDelivery_address'))
              .card_number,
      id_card_type:
        isGuest !== 'yes'
          ? (accountInfoData?.message?.i_card_type ?? '')
          : JSON.parse(localStorage.getItem('guestDelivery_address'))
              .cc_id_card_Type,
      id_card_dob:
        isGuest !== 'yes'
          ? (accountInfoData?.message?.i_card_dob ?? '')
          : JSON.parse(localStorage.getItem('guestDelivery_address'))
              .dateOfBirth,
      id_card_expiry:
        isGuest !== 'yes'
          ? (accountInfoData?.message?.i_card_ex_date ?? '')
          : JSON.parse(localStorage.getItem('guestDelivery_address'))
              .expiry_date,
      id_card_front_img:
        isGuest !== 'yes'
          ? (accountInfoData?.message?.i_card_front_img ?? '')
          : localStorage.getItem('imageName'),
      del_fname:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.f_name ?? '')
          : (selectedDeliveryAdderess?.address?.d_f_name ?? ''),
      del_lname:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.l_name ?? '')
          : (selectedDeliveryAdderess?.address?.d_l_name ?? ''),
      del_phone:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.phone ?? '')
          : (selectedDeliveryAdderess?.address?.d_mobile ?? ''),
      del_address:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.a_address_line_1 ?? '')
          : (selectedDeliveryAdderess?.address?.a_address_line_1 ?? ''),
      del_address_2:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.a_address_line_2 ?? '')
          : (selectedDeliveryAdderess?.address?.a_address_line_2 ?? ''),
      del_city:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.a_city ?? '')
          : (selectedDeliveryAdderess?.address?.a_city ?? ''),
      del_state:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.a_state ?? '')
          : (selectedDeliveryAdderess?.address?.a_state ?? ''),
      del_zip:
        selectedDeliveryAdderess?.billing === 'yes'
          ? (selectedDeliveryAdderess?.address?.a_zip ?? '')
          : (selectedDeliveryAdderess?.address?.a_zip ?? ''),
      orderMethod: storeDataState?.orderMethod ?? '',
      coupon_name: couponData?.name ?? '',
      // discount_amt: parseFloat(finalAmountInfo.couponPrice) ?? '',
      discount_amt: parseFloat(finalDiscountAmount).toFixed(2) ?? '',
      coupon_id: couponData?.id ?? '',
      tip_amt: finalAmountInfo?.mytipamt,
      convfee_amt: finalAmountInfo?.conFee,
      delfee_amt: finalAmountInfo?.deliveryCharge
        ? finalAmountInfo?.deliveryCharge
        : 0,
      // sub_total: parseFloat(finalAmountInfo?.subTotal),
      sub_total: parseFloat(finalSubTotal).toFixed(2),
      tax: finalCalculateDefaultTax('default') || 0,
      tax_rate: finalCalculateDefaultTax('defaultPercent') || 0,
      other_tax: finalCalculateOtherTax() ?? '',
      other_tax_desc: calculateOtherTaxdesc() ?? '',
      other_taxes_rate_desc: otherTaxesRateDesc,
      grand_total: parseFloat(finalAmountInfo?.grandTotal).toFixed(2) ?? 0,
      ...(depositAmt > 0
        ? { deposit_amt: depositAmt.toFixed(2), deposit_fee_name: depositFeeName() }
        : {}),
      // sms_notify: sendNotifications ? 'on' : 'off',
      sms_notify: notificationSettings?.orderText ? 'on' : 'off',
      email_notify: notificationSettings?.orderPush ? '1' : '0',
      cc_name:
        paymentDPdata?.newCard?.cardname !== ''
          ? paymentDPdata?.newCard?.cardname
          : paymentDPdata?.selectedCard?.cardname,
      cc_number:
        paymentDPdata?.newCard?.cardnumber !== ''
          ? paymentDPdata?.newCard?.cardnumber
          : paymentDPdata?.selectedCard?.ccnum4last,
      cc_month:
        paymentDPdata?.newCard?.expiredate !== ''
          ? paymentDPdata?.newCard?.expiredate?.split(' ')[0]
          : paymentDPdata?.selectedCard?.expires?.substring(0, 2),
      cc_year:
        paymentDPdata?.newCard?.expiredate !== ''
          ? paymentDPdata?.newCard?.expiredate?.split(' ')[1]?.substring(2)
          : paymentDPdata?.selectedCard?.expires?.substring(2, 5),
      cc_cvv:
        paymentDPdata?.newCard?.cvv !== '' ? paymentDPdata?.newCard?.cvv : '',
      radiocc: paymentDPdata?.selectedCard?.key ?? '',
      // credit card key
      savecard: paymentDPdata?.newCard?.saveFuture === true ? 1 : 0,
      ...(paymentDPdata?.paymentType === 'newdebitcard' &&
      paymentDPdata?.newCard?.payrocToken
        ? { payroc_single_use_token: paymentDPdata.newCard.payrocToken }
        : {}),
      // items: JSON.stringify(Items),
      newLineItems: JSON.stringify(newLineItems),
      enable_loyalty: lp_sc_data?.enable_loyalty,
      store_credit_amt: lp_sc_data?.store_credit_amt,
      spend_loyality_amount: lp_sc_data?.spend_loyality_amount,
      spend_loyality_points: lp_sc_data?.spend_loyality_points,
      total_lp_apply_amt:
        isNaN(lp_sc_data?.total_lp_apply_amt) || isGuest === 'yes'
          ? '0.00'
          : lp_sc_data.total_lp_apply_amt,
      total_lp_earn_amt:
        isNaN(lp_sc_data?.total_lp_earn_amt) || isGuest === 'yes'
          ? '0.00'
          : lp_sc_data.total_lp_earn_amt,
      created_date: formatDateTimeOnly(new Date(), 'createdDateInSaveOrder'),
      bogo_discount: parseFloat(totalBogoDiscount).toFixed(2),
      group_id: groupId?.groupId || '',
      mix_match_discount: parseFloat(totalMixMatchDiscount).toFixed(2),
      uber_quote_id: deliveryQuoteData?.quote_id || '',
      idempotency_key: _uuid,
      // Stored with the order for the server-side mKonnekt reporting sweep;
      // all '' unless dezi is on and the quote matches this cart's request.
      ...buildMkonnektOrderQuoteFields({
        isDeziEnabled,
        mkonnektDiscounts,
        requestBody: mkonnektDiscountRequestBody,
      }),
    };

    // if (groupId?.groupId) {
    //   data.group_id = groupId?.groupId;
    // }
    return {
      data,
      hasItems: Object.values(newLineItems).length > 0,
    };
  };

  const place_Order = async (...args) => {
    const built = buildPlaceOrderData(...args);

    if (!built.hasItems) {
      alert('No Products Found, Please add products to purchase!');
      return { status: false, error: 'No Cart Items' };
    }

    // Step B: attach selfie_token (stashed by BillingInfoLogic after a
    // successful selfie verification). PHP's _saveGuestIdCard verifies
    // and persists selfie fields on guest_id_card. Clear after the POST
    // so the next order forces a fresh capture.
    // After refactor `data` lives inside buildPlaceOrderData; mutate the
    // returned payload via `built.data`.
    try {
      const stashedSelfieToken = sessionStorage.getItem('qv_selfie_token');
      if (stashedSelfieToken) built.data.selfie_token = stashedSelfieToken;
    } catch (e) { /* storage disabled — field stays absent */ }

    try {
      const response = await axios.post(
        BASE_URL_SANDBOX + SAVE_ORDER,
        built.data,
        { headers: { 'Content-Type': 'multipart/form-data' } },
      );
      if (response) {
        // Selfie token is single-use per order — clear so the next order
        // requires a fresh capture (HMAC has its own exp but clearing is
        // belt-and-suspenders against stale reuse).
        try { sessionStorage.removeItem('qv_selfie_token'); } catch (e) {}
        return response.data;
      }
    } catch (error) {
      const responseData = error?.response?.data;

      // Validation failures are part of the save-order contract. Preserve the
      // complete payload so checkout can act on error_code and refreshed wallet
      // balances instead of reducing it to an unobservable thrown Error.
      if (
        responseData &&
        typeof responseData === 'object' &&
        !Array.isArray(responseData)
      ) {
        return responseData;
      }

      throw new Error(
        responseData?.message ||
          error?.message ||
          'Unable to place the order. Please try again.',
      );
    }
  };

  const formatTimeRange = (open_time, close_time) => {
    const openTimes = open_time.split(',');
    const closeTimes = close_time.split(',');

    // Initialize an array to store the formatted time ranges
    const formattedTimeRanges = [];

    // Iterate through the arrays and format the time ranges
    for (let i = 0; i < openTimes.length; i++) {
      const openTime = openTimes[i].trim();
      const closeTime = closeTimes[i].trim();

      // Parse the time strings into Date objects for easier manipulation
      const openDate = new Date(`2000-01-01T${openTime}`);
      const closeDate = new Date(`2000-01-01T${closeTime}`);

      // Adjust the date for closing time if it's before the opening time
      if (closeDate < openDate) {
        closeDate.setDate(closeDate.getDate() + 1);
      }

      // Format the time in HH:mm AM/PM format
      const formattedOpenTime = openDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });
      const formattedCloseTime = closeDate.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });

      // Add the formatted time range to the array
      formattedTimeRanges.push({
        open_time: formattedOpenTime,
        close_time: formattedCloseTime,
      });
    }

    return formattedTimeRanges;
  };

  // checking if image is available or not
  function checkIfImageExists(url) {
    const img = new Image();
    img.src = url;
    let result = false;

    if (img.complete) {
      result = true;
    } else {
      img.onload = () => {
        result = true;
      };

      img.onerror = () => {
        result = false;
      };
    }
    return result;
  }

  return {
    checkIfImageExists,
    getCurrentDateTime,
    handleGetVariData,
    filterVarientDataFromCart,
    formatDate,
    updateProductFromCart,
    removeProductFromCart,
    handleDeleteCartProduct,
    handleUpdateCartItem,
    filterCartData,
    varientTransformer,
    filterProductData,
    isValidJSON,
    isDecodedData,
    getProductQuantity,
    UpdateQuantity,
    checkInCart,
    AddtoCart,
    validateEmail,
    validatePassword,
    validateOldPassword,
    validatePhoneNumber,
    validateConfrimPassword,
    validateFirstName,
    validateLastName,
    validateStreetAddress,
    validateZipCode,
    validateCity,
    validateState,
    validateIdNumber,
    formatCreditCardNumber,
    validateCardNumber,
    validateApartment,
    validateIDproof,
    validateExpiredate,
    validateDOB,
    validateImageProof,
    convertToIndianTime,
    percentOffItem,
    validatePasswordBlank,
    validateCaptcha,
    formatExireDate,
    getImageExtension,
    validateCoupon,
    handleImagesArray,
    place_Order,
    buildPlaceOrderData,
    JsonItem,

    /**
     * Transform raw cart items into the same processed format that
     * place_Order sends to PHP. Used by the wallet flow so Node
     * receives the exact same payload as PHP — same fields, same
     * taxes, same qty splitting, same BOGO/mix-match adjustments.
     */
    buildProcessedLineItems: (
      cartItems,
      taxDetailApiData,
      allCategories,
      percentageDeducCoupon = 0,
      percentageDeducLoy = 0,
      spendLoyaltyAmount = 0,
      bogoListData = [],
      mixAndMatchListData = [],
    ) => {
      // mKonnekt (dezi) runs first so tobacco items are excluded from local deals
      const afterMkonnekt = isDeziEnabled
        ? handleMkonnektDiscounts(cartItems, mkonnektDiscounts)
        : cartItems;
      const afterPCD = handleProductCategoryDiscounts(
        afterMkonnekt,
        productCategoryDiscounts,
      );
      const afterBogo = handleBogoDeals(
        afterPCD,
        bogoListData?.bogoList || bogoListData || [],
      );
      const afterMM = handleMixAndMatchDeals(
        afterBogo,
        mixAndMatchListData?.mixAndMatchList || mixAndMatchListData || [],
      );
      const Items = JsonItem(
        afterMM,
        taxDetailApiData,
        allCategories,
        percentageDeducCoupon,
        percentageDeducLoy,
        spendLoyaltyAmount,
      );

      // qty splitting — exact same logic as place_Order lines 1590-1613
      const splitOtherTaxes = (taxObj, qty) => {
        try {
          const json = JSON.parse(taxObj);
          const newObj = {};
          for (let key in json) newObj[key] = json[key] / qty;
          return JSON.stringify(newObj);
        } catch {
          return '';
        }
      };

      const result = [];
      Object.values(Items).forEach((item) => {
        if (item.qty > 1) {
          for (let i = 0; i < item.qty; i++) {
            result.push({
              ...item,
              tax: item.tax / item.qty,
              qty: 1,
              coupon_code_amt:
                parseFloat(item.coupon_code_amt) &&
                !isNaN(item.coupon_code_amt)
                  ? item.coupon_code_amt / item.qty
                  : 0,
              other_tax: item.other_tax / item.qty,
              other_tax_desc: item.other_tax_desc
                ? splitOtherTaxes(item.other_tax_desc, item.qty)
                : '',
            });
          }
        } else {
          result.push(item);
        }
      });

      return result;
    },
    validateCardExpiredate,
    validateCvv,
    formatTimeRange,
    pennyFixLogic,
    validateCardName,
  };
};

export default Validation;

